import { render, staticRenderFns } from "./to-be-mailed.vue?vue&type=template&id=b4c717b6"
import script from "./to-be-mailed.vue?vue&type=script&lang=js"
export * from "./to-be-mailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports